export const initialState = {
    userFeed: { meta: null, data: null },
    error: false,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'OLY_ENGINE_STORE_LOAD_USER_FEED':
            return { ...state, error: initialState.error };
        case 'OLY_ENGINE_STORE_LOAD_USER_FEED_SUCCESS':
            return {
                ...state,
                userFeed: action.payload.userFeed,
            };
        case 'OLY_ENGINE_STORE_LOAD_USER_FEED_ERRROR':
            return {
                ...state,
                error: action.payload.error,
            };
        case 'OLY_ENGINE_STORE_RESET_USER_FEED':
            return initialState;
        default:
            return state;
    }
};
export default reducer;
